import { isSuggestedStatus } from './status';
import { getFeatureGates } from './auth/featureAccess';
/** Filters out suggestions if user ungated for agentSunset feature gate */
export const hideSuggestionsInHydratedReports = strategies => {
  if (!getFeatureGates().agentSunset) {
    return strategies;
  }
  return strategies.map(strategy => {
    const variants = strategy.personalizationReports;
    const hasSuggestions = variants.some(variant => isSuggestedStatus(variant.status));
    if (!hasSuggestions) {
      return strategy;
    }
    return Object.assign({}, strategy, {
      personalizationReports: variants.filter(variant => !isSuggestedStatus(variant.status))
    });
  });
};

// Filters out agent suggestions if user is ungated for agentSunset feature gate
export const filterOutAgentSuggestions = variant => {
  var _variant$assetData;
  return !getFeatureGates().agentSunset || ((_variant$assetData = variant.assetData) === null || _variant$assetData === void 0 ? void 0 : _variant$assetData.publishStatus) !== 'aiSuggested';
};